module.exports = __webpack_public_path__ + "images/frontpage_settings@3x.png?27c90a2f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_settings@3x.png
// module id = 659
// module chunks = 7